import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ImageIcon } from 'lucide-react';
const solutions = [{
  title: 'Community',
  description: 'Weekly neighbor meals in the shared kitchen. Familiar faces in the courtyard. People close enough for everyday support, not just special occasions.',
  image: 'https://cdn.magicpatterns.com/uploads/5pN1VUq7KzYwVkzjtr1f4Q/Community_image.jpg',
  alt: 'Neighbors gathered in conversation in a planted courtyard'
}, {
  title: 'Affordable abundance',
  description: 'Shared access to amenities that would feel extravagant alone: sauna, guest rooms, creative spaces, shared kitchen, flexible work areas, play spaces, and gardens.',
  image: 'https://cdn.magicpatterns.com/uploads/m5Y387PxVqokKT8N3Dp1j2/image.png',
  alt: 'A large communal kitchen with a long shared dining table'
}, {
  title: 'Privacy or sociability',
  description: 'Your own front door when you want quiet. Shared spaces when you want connection. A place designed for introverts, extroverts, families, elders, and friends.',
  image: 'https://cdn.magicpatterns.com/uploads/jBM26JUFH189brpwRroHPS/image.png',
  alt: 'Residents gathered in the shared atrium of a co-housing building'
}, {
  title: 'Healthier for kids',
  description: 'A nurturing environment where kids can play freely, build mixed-age friendships, and be surrounded by adults their families trust.',
  image: 'https://cdn.magicpatterns.com/uploads/5AsFv5LH1afDUhci3P4YG5/image.png',
  alt: 'Children playing soccer in a shared courtyard while neighbors gather nearby'
}, {
  title: 'Intentional design',
  description: 'Spaces designed around real routines: meals, care, work, visitors, play, aging, celebration, and rest.',
  image: 'https://cdn.magicpatterns.com/uploads/iZY2cyZ6fA5A9As7D6dJq3/image.png',
  alt: 'Exterior of a timber-clad co-housing building with planted balconies'
}, {
  title: 'Chosen family',
  description: 'A broader idea of family — friends, neighbors, parents, grandparents, godparents, and the people you want nearby.',
  image: 'https://cdn.magicpatterns.com/uploads/wZwcZbQBeAr9FDtFjFedBa/image.png',
  alt: 'A group of friends watching fireworks together from a terrace'
}];
export function SolutionSection() {
  return <section className="py-32 px-6 md:px-12 bg-cream" data-id="element-287">
      <div className="max-w-7xl mx-auto" data-id="element-288">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-20 max-w-3xl" data-id="element-289">
          <span className="text-xs font-sans font-bold uppercase tracking-[0.2em] text-marigold mb-4 block" data-id="element-290">
            The solution
          </span>
          <h2 className="text-4xl md:text-5xl text-navy mb-6 font-serif tracking-wide" data-id="element-291">
            Your private + shared life, designed from the start.
          </h2>
          <p className="text-lg text-navy/70 font-light leading-relaxed" data-id="element-292">
            Familiar Spaces brings together private homes, intentional shared
            spaces, and a community that forms before move-in — so the building
            reflects the lives of the people who will use it.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-293">
          {solutions.map((solution, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl border border-navy/10 overflow-hidden flex flex-col group" data-id="element-294">
              <div className="aspect-[4/3] w-full overflow-hidden border-b border-navy/5" data-id="element-295">
                {solution.image ? <img src={solution.image} alt={solution.alt} className="w-full h-full object-cover" data-id="element-296" /> : <div className="w-full h-full bg-navy/5 flex flex-col items-center justify-center text-navy/30 gap-2" data-id="element-297">
                    <ImageIcon className="w-8 h-8" data-id="element-298" />
                    <span className="text-xs font-medium uppercase tracking-wider" data-id="element-299">
                      Add image
                    </span>
                  </div>}
              </div>
              <div className="p-8 flex flex-col" data-id="element-300">
                <h3 className="text-xl font-serif tracking-wide text-navy mb-3" data-id="element-301">
                  {solution.title}
                </h3>
                <p className="text-navy/70 text-sm leading-relaxed" data-id="element-302">
                  {solution.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}